export const LeadDetailsShimmer = () => {
  return (
    <div className="rounded-lg bg-gray-50 p-6 shadow-md">
      <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-4">
        <div>
          <div className="mb-1 h-4 w-24 rounded bg-gray-300 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
          <div className="h-6 w-32 rounded bg-gray-200 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
        </div>
        <div>
          <div className="mb-1 h-4 w-24 rounded bg-gray-300 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
          <div className="h-6 w-32 rounded bg-gray-200 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
        </div>
        <div>
          <div className="mb-1 h-4 w-16 rounded bg-gray-300 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
          <div className="h-6 w-48 rounded bg-gray-200 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
        </div>
        <div>
          <div className="mb-1 h-4 w-32 rounded bg-gray-300 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
          <div className="h-6 w-40 rounded bg-gray-200 animate-pulse bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300" />
        </div>
      </div>
    </div>
  );
};
